/**
 * Handles event tracking
 * @param {string} selector Optional CSS selector for links to track
 * @constructor
 */
function LinkTracker(selector) {
  const self = this;
  /**
   * Creates dataLayer array from existing dataLayer, or new empty array if non specified
   * @type {Array|*|Window.dataLayer}
   */
  this.dataLayer = window.dataLayer = window.dataLayer || [];
  /**
   * Selector for anchors that should be tracked
   * @type {string}
   */
  this.linksSelector = selector || 'a[data-ua-category][data-ua-action], button[data-ua-category][data-ua-action]';

  $('body').on('click', this.linksSelector, { dataLayer: this.dataLayer }, this.track);

  $('div[data-ua-category][data-ua-action], section[data-ua-category][data-ua-action]').on('click', 'a:not([data-ua-category])', function createInteraction() {
    if (typeof $(this).data('ua-dont-track') === "undefined") {
      const data = $(this).closest('[data-ua-category][data-ua-action]').data();

      self.dataLayer.push({
        event: 'gp-interaction',
        category: data.uaCategory,
        action: data.uaAction,
        label: data.uaLabel || `From:${document.location.pathname + document.location.search} To:${$(this).attr('href')}`,
        'interaction-type': true
      });
    }
  });
}

/**
 * Web tracking function
 * @param event Click action
 */
LinkTracker.prototype.track = function track(event) {
  const target = ((eventTarget) => {
    if (eventTarget === 'A' || eventTarget === 'BUTTON') return $(eventTarget);
    return $(eventTarget).closest('a, button');
  })(event.target);
  const data = target.data();
  const to = (() => {
    if (target.is('button')) {
      return target.closest('form').attr('action');
    }
    return target.attr('href');
  })();

  if (typeof data.uaDontTrack === "undefined") {
    event.data.dataLayer.push({
      event: 'gp-interaction',
      category: data.uaCategory,
      action: data.uaAction,
      label: data.uaLabel || `From:${document.location.pathname + document.location.search} To:${to}`,
      'interaction-type': false
    });
  }
};

export default LinkTracker;
